import {Component, Input, OnInit} from '@angular/core';
import {TranslatedNames} from "../../../models/turns-models/translated-names.model";

@Component({
  selector: 'app-turns-desk-translations',
  templateUrl: './turns-desk-translations.component.html',
  styleUrls: ['./turns-desk-translations.component.scss']
})
export class TurnsDeskTranslationsComponent implements OnInit {

  @Input() translations: Array<TranslatedNames>;

  constructor() {}

  ngOnInit() {}
  
}
